import React from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import App from './App'
import './App.css'

import { HelmetProvider } from 'react-helmet-async'
import { ThemeProvider } from './ThemeContext'

// Statiske SEO-tags fra index.html og scripts/prerender.mjs (data-rh="true") er
// til søgemaskiner, der ikke kører JavaScript. Når appen starter, fjernes de, så
// sidens egne tags fra react-helmet-async ikke kommer oveni som dubletter.
document.querySelectorAll('head [data-rh]').forEach((el) => el.remove())

createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <ThemeProvider>
      <HelmetProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/*" element={<App />} />

          </Routes>
        </BrowserRouter>
      </HelmetProvider>
    </ThemeProvider>
  </React.StrictMode>
)
